import { utils } from '@febos-io/common';

export const payCompanyOrder = (
  companyId,
  orderId,
  {
    comprobanteType,
    paymentMethod,
  }
) => ({
  path: `/v1/documents/dental-order/${orderId}/pay`,
  method: utils.METHOD.POST,
  content: {
    comprobanteType,
    paymentMethod,
  },
  params: { companyId, },
});

export const notifyOrderToPatient = (
  orderId
) => ({
  path: `/v1/documents/dental-order/${orderId}/notify`,
  method: utils.METHOD.POST,
});
